import { useState, useEffect, useRef } from "react";
import AgentHieararchyAPI from "../../../api/AgentHieararchyAPI";

const useFetchAgentHierarchy = (params = {}) => {
	const { agentId = null, period = null } = params ?? {};
	const [loading, setLoading] = useState(false);
	const [hierarchy, setHierarchy] = useState(null);

	const abortControllerRef = useRef(null);

	const fetchAgentHierarchy = async (overrideParams = {}) => {
		const params = {
			agent_id: agentId,
			period,
			...overrideParams,
		};

		if (abortControllerRef.current) {
			abortControllerRef.current.abort();
		}

		abortControllerRef.current = new AbortController();
		const signal = abortControllerRef.current.signal;

		setLoading(true);

		try {
			const result = await AgentHieararchyAPI.getAgentHierarchy({
				agent_id: params.agent_id,
				period: params.period,
				signal,
			});

			setHierarchy(result);
		} catch (error) {
			if (error.name === "AbortError") return;

			console.error("Failed to fetch agent hierarchy:", error);
			setHierarchy(null);
		} finally {
			if (!signal.aborted) {
				setLoading(false);
			}
		}
	};

	useEffect(() => {
		fetchAgentHierarchy();

		return () => {
			abortControllerRef.current?.abort();
		};
	}, [agentId, period]);

	return {
		hierarchy,
		loading,
		refetch: fetchAgentHierarchy,
	};
};

export default useFetchAgentHierarchy;
